import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Ribbon } from "../components/Ribbon";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { About } from "../components/About";
import { Paths } from "../components/Paths";
import { Pricing } from "../components/Pricing";
import { BookingSection } from "../components/BookingSection";
import { PaymentsSection } from "../components/PaymentsSection";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { useLenis } from "../hooks/useLenis";

export default function Home() {
    useLenis();
    return (
        <div className="bg-paper text-ink min-h-screen">
            <Nav />
            <main>
                <Hero />
                <Ribbon />
                <Services />
                <Portfolio />
                <About />
                <Paths />
                <Pricing />
                <BookingSection />
                <PaymentsSection />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
